import { useState } from "react";
import { MOTIVOS, denunciar, type MotivoId, type TipoDeDenuncia } from "@/data/moderacao";

/* A folha de denúncia. Sobe de baixo, fecha tocando fora — mesmo gesto
   da barra de reação, para não inventar um segundo jeito de fechar. */

export interface Alvo {
  tipo: TipoDeDenuncia;
  cid: string;
  pid: string;
  alvoUid: string;
  /** Só para o texto da tela saber o que está sendo denunciado. */
  oQue: string;
}

export function Denunciar(
  { quem, alvo, aoFechar }:
  { quem: string; alvo: Alvo; aoFechar: () => void },
) {
  const [motivo, setMotivo] = useState<MotivoId | null>(null);
  const [texto, setTexto] = useState("");
  const [indo, setIndo] = useState(false);
  const [pronto, setPronto] = useState(false);

  async function enviar() {
    if (!motivo || indo) return;
    setIndo(true);
    try {
      await denunciar(quem, alvo, motivo, texto);
      setPronto(true);
    } catch {
      // Falhar calado seria pior: a pessoa acha que denunciou e não
      // denunciou. Melhor devolver o botão e deixar tentar de novo.
      setIndo(false);
    }
  }

  return (
    <div className="reacao-fundo" onClick={aoFechar} role="presentation">
      <div className="folha" onClick={(e) => e.stopPropagation()}>
        {pronto ? (
          <>
            <div className="folha-titulo">Denúncia enviada</div>
            <p className="folha-texto">
              A gente olha em até 24 horas. Se preferir não ver mais nada
              dessa pessoa agora, dá pra bloquear — some na hora e não
              avisa ninguém.
            </p>
            <button className="btn btn-primary" onClick={aoFechar}>Fechar</button>
          </>
        ) : (
          <>
            <div className="folha-titulo">Denunciar {alvo.oQue}</div>
            <div className="folha-opcoes">
              {MOTIVOS.map((m) => (
                <button key={m.id}
                  className={`folha-opcao ${motivo === m.id ? "on" : ""}`}
                  onClick={() => setMotivo(m.id)}>
                  {m.label}
                </button>
              ))}
            </div>
            <input className="folha-campo" value={texto} maxLength={500}
              placeholder="Quer contar mais? (opcional)"
              onChange={(e) => setTexto(e.target.value)} />
            <button className="btn btn-primary" disabled={!motivo || indo}
              onClick={() => void enviar()}>
              {indo ? "Enviando…" : "Enviar denúncia"}
            </button>
            <button className="btn btn-white" onClick={aoFechar}>Cancelar</button>
          </>
        )}
      </div>
    </div>
  );
}
